import { render, staticRenderFns } from "./filterForGrid.vue?vue&type=template&id=20bd3331&"
import script from "./filterForGrid.vue?vue&type=script&lang=js&"
export * from "./filterForGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports